<template>
  <van-checkbox-group v-model="checkboxGroup" ref="checkboxGroup">
  <van-cell-group>
    <van-cell v-for="(item, index) in data" :key="index">
      <template #right-icon>
        <van-icon v-show="item.children && item.children.length > 0" name="arrow-down" v-if="item.expanded" @click="toggle(item)" />
        <van-icon v-show="item.children && item.children.length > 0" name="arrow-up" v-else @click="toggle(item)" />
      </template>
      <template #title>
        <div slot="title" class="solt-title">
          <van-checkbox :name="item" v-model="item.checked" shape="square" class="van-cell-checkbox" @click="checkClick(item)">{{item.label}}</van-checkbox>
          <van-field
            input-align="right"
            label=""
            v-model="item.value"
            type="number"
            @blur="handleBlur(item)"
            :class="item.checked?'van-cell-text show':'van-cell-text'"
            placeholder="请输入报销金额" />
        </div>
        <!-- 条件判断是否需要嵌套表格 -->
        <nested-table v-if="item.expanded&&item.children && item.children.length > 0" @data-from-child="handleBlur(item.children)" :data="item.children"></nested-table>
      </template>
    </van-cell>
  </van-cell-group>
  </van-checkbox-group>
</template>

<script>
  export default {
    name: "NestedTable",
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        checkboxGroup: []
      }
    },
    mounted() {
      this.showSelectedDepartCheckData(this.data);
    },
    watch: {
      data(newVal, oldVal) {
        this.showSelectedDepartCheckData(newVal);
      }
    },
    methods: {
      //将已选择的部门数据统计下来
      showSelectedDepartCheckData(data) {
        this.checkboxGroup=new Array();
        let arrayList = data;
        if (arrayList && arrayList != null && arrayList.length > 0) {
          arrayList.forEach((item, index) => {
            if(item.checked) {
              this.checkboxGroup.push(item);
            }
            //检查该节点是否有子节点
            if (item.children && item.children != null && item.children.length > 0) {
              this.showSelectedChildCheckData(arrayList, item.children);
            }
          })
        }
      },
      //循环绑定已选择的部门数据
      showSelectedChildCheckData(list,childs){
        childs.forEach((item,index)=>{
          if(item.checked) {
            this.checkboxGroup.push(item);
          }
          if(item.children&&item.children!=null&&item.children.length>0) {
            this.showSelectedChildCheckData(list,item.children);
          }
        })
      },
      //点击并同时将数据推送给父级
      checkClick(item){
        item.value="";
        if(item.checked) {
          item.checked = false;
        }
        else{
          item.checked=true;
        }
        this.handleBlur(item);
      },
      toggle(item) {
        item.expanded = !item.expanded;
      },
      //将数据发送给父级使用
      handleBlur(item) {
        this.$emit('data-from-child', item);
      }
    }
  }
</script>

<style scoped>
  ::v-deep.van-icon-arrow-up {
    padding:15px 0 0;
  }
  ::v-deep.van-icon-arrow-down {
    padding:15px 0 0;
  }
  ::v-deep.solt-title{
    width:100%;
    display: flex;
    display: -webkit-flex;
    display: -ms-flexbox;
  }
  ::v-deep.van-cell-checkbox{
    width:20%;
  }
  ::v-deep.van-cell-text{
    width:80%;
    opacity: 0;
    -moz-opacity: 0;
  }
  ::v-deep.van-cell-text.show{
    opacity: 1;
    -moz-opacity: 1;
  }
</style>
